import {Navigate,useLocation} from "react-router-dom";
import Cookies from 'universal-cookie';
export default function RouterGuard({isPvt,children}) {
  const cookies = new Cookies();
  let location = useLocation();  
  let auth = cookies.get('auth');
  if(isPvt===1 && !auth && !auth?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
